export const postScreenInterview = {
  title: 'Vector Marketing - Final Application',
  label: 'Final Questions',
  banner: '',
  fields: {
    joinTeam: {
      group_title: '',
      group: 'impression',
      title:
        'If accepted for a position, would you be excited to join the Vector team?',
      type: 'Radio',
      validators: ['required'],
      options: [
        {
          label: 'Yes',
          val: 'Yes',
        },
        {
          label: 'No',
          val: 'No',
        },
      ],
    },

    topOptions: {
      group: 'impression',
      title: 'What excites you about the position the most?',
      help: 'Select your top three options!',
      type: 'Checkboxes',
      validators: ['required'],
      max: 3,
      options: [
        {
          label: 'The flexible schedules',
          val: 'Flexible schedules',
        },
        {
          label: 'Getting promoted',
          val: 'Advancement',
        },
        {
          label: 'The income opportunity',
          val: 'Income opportunity',
        },
        {
          label: 'Building my skills',
          val: 'Skill building',
        },
        {
          label: 'The team/environment',
          val: 'Team / environment',
        },
        {
          label: 'Gaining experience for my résumé',
          val: 'Resumé experience',
        },
        {
          label: 'The product',
          val: 'product',
        },
      ],
    },

    currentResidence: {
      group: 'impression',
      title: 'What city do you live in? How long?',
      label: 'Text',
      dark: true,
      type: 'TextArea',
      limit: 500,
      validators: ['required'],
    },

    previousWorkExperience: {
      group: 'impression',
      title: 'List any previous work experience (including volunteer work)',
      label: 'Text',
      dark: true,
      type: 'TextArea',
      limit: 500,
      validators: ['required'],
    },

    previousOrganizations: {
      group: 'impression',
      title:
        'Were you part of any sports, clubs and/or leadership positions in school?',
      label: 'Text',
      dark: true,
      type: 'TextArea',
      limit: 500,
      validators: ['required'],
    },

    whySuccessful: {
      group: 'impression',
      title:
        'If accepted for a position and given the proper training, why do you think you would be successful?',
      label: 'Text',
      dark: true,
      type: 'TextArea',
      limit: 500,
      validators: ['required'],
    },

    workingGoals: {
      group_title: '',
      group: 'future',
      title:
        'What are some goals you have for your future? And if accepted for a position how would Vector help you achieve those goals?',
      label: 'Text',
      dark: true,
      type: 'TextArea',
      limit: 500,
      validators: ['required'],
    },
  },
};

export const preScreenInterview = {
  title: 'WELCOME TO YOUR INTERVIEW',
  label: 'Intro Questions',
  introText:
    '<p>We’ll be getting started soon.</p>' +
    '<p>In the meantime, please introduce yourself by answering these three questions:</p>',
  banner: '',
  fields: {
    live: {
      title: 'How long have you lived in the area?',
      label: 'Text',
      dark: true,
      type: 'Text',
      validators: ['required'],
      office: '1',
    },
    work: {
      title:
        'Students: High school attended, College / University - Major<br>' +
        'Non-students: Are you currently working? What do you do?',
      label: 'Text',
      dark: true,
      type: 'TextArea',
      limit: 500,
      validators: ['required'],
    },
    proud: {
      title:
        'What is one thing you’re proud of? (Activity, hobby, accomplishment, academics, sports, etc)',
      label: 'Text',
      dark: true,
      type: 'TextArea',
      limit: 500,
      validators: ['required'],
    },
    goal: {
      title: 'Other than money, what are you looking for in a job?',
      label: 'Text',
      dark: true,
      type: 'TextArea',
      limit: 500,
      validators: ['required'],
    },
    availability: {
      title: 'How soon are you available to start work?',
      label: 'Text',
      dark: true,
      type: 'Text',
      validators: ['required'],
    },
  },
};

export default {
  postScreenInterview,
  preScreenInterview,
};
